function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { AppContext } from 'context';
import { useAction } from 'hooks';
import copyTextToClipboardFallback from 'helpers/copyTextToClipboardFallback';
import Button from 'components/Form/Button';
import CopyIcon from 'svg/copy.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './SccInit.pcss';
const SectionStep = ({ stepNo })=>/*#__PURE__*/ _jsxs("h4", {
        className: "text--bold",
        children: [
            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.labels.step)),
            " ",
            stepNo
        ]
    });
const DownloadStep = ()=>{
    const { apiUrl } = useContext(AppContext);
    const locale = useSelector(App.selectors.locale);
    const language = locale.slice(0, 2);
    const urlLocale = get(constants.SINOVO_LANGUAGES, language, 'EN');
    return /*#__PURE__*/ _jsxs("div", {
        className: "modal__section",
        children: [
            /*#__PURE__*/ _jsx(SectionStep, {
                stepNo: 1
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sccInstall.downloadInfo))
            }),
            /*#__PURE__*/ _jsx(Button, {
                type: "link",
                to: `${apiUrl}/scc/SINOVOConnectionCenter-GCO-Setup-${urlLocale}.exe`,
                styleModifier: "primary",
                labelMessage: messages.buttons.installScc,
                className: "btn--block mb-0",
                data: {
                    download: true
                }
            })
        ]
    });
};
const CopyPairingCodeToClipboard = ()=>{
    const machineId = useSelector(selectors.sccMachineId);
    const pairingCode = useSelector(selectors.sccPairingCode);
    if (machineId) {
        return /*#__PURE__*/ _jsx("span", {
            className: "text--normal text--light text--small d-block py-3",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.continueToNextStep))
        });
    }
    const onCopyPairingCodeToClipboard = ()=>{
        if (!navigator.clipboard) {
            copyTextToClipboardFallback(pairingCode);
            return;
        }
        navigator.clipboard.writeText(pairingCode);
    };
    return /*#__PURE__*/ _jsxs(Button, {
        styleModifier: "transparent",
        className: "btn--sm",
        onClick: onCopyPairingCodeToClipboard,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "text--normal text--light text--small",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.buttons.clickToCopy))
            }),
            /*#__PURE__*/ _jsx(CopyIcon, {
                className: styles.copyIcon
            })
        ]
    });
};
const PairingCode = ()=>{
    const machineId = useSelector(selectors.sccMachineId);
    const pairingCode = useSelector(selectors.sccPairingCode);
    if (!machineId && !pairingCode) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.pairingCodeContainer,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.pairingCodeContainerInner,
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.pairingCode,
                        children: pairingCode
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(CopyPairingCodeToClipboard, {})
                    })
                ]
            })
        })
    });
};
const PairingStep = ()=>{
    const b = (chunk)=>/*#__PURE__*/ _jsx("b", {
            children: chunk
        });
    return /*#__PURE__*/ _jsxs("div", {
        className: "modal__section",
        children: [
            /*#__PURE__*/ _jsx(SectionStep, {
                stepNo: 2
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.sccInstall.pairingInfo), {
                    values: {
                        b
                    }
                }))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row mt-6",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-6",
                        children: /*#__PURE__*/ _jsx(PairingCode, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-6",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/assets/svg/sinovo-otp.svg",
                            alt: ""
                        })
                    })
                ]
            })
        ]
    });
};
const ConnectionStep = ({ onSetComponent })=>{
    const machineId = useSelector(selectors.sccMachineId);
    const btnLabelMessage = messages.buttons[machineId ? 'downloadData' : 'waitingForConnection'];
    const onConnect = ()=>{
        onSetComponent('Waiting');
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "modal__section",
        children: [
            /*#__PURE__*/ _jsx(SectionStep, {
                stepNo: 3
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sccInstall.connectionInfo))
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: btnLabelMessage,
                className: "btn--block btn--filled mb-0",
                isDisabled: !machineId,
                onClick: onConnect
            })
        ]
    });
};
const InstallDownloader = ({ onSetComponent, onSetHeaderMessage })=>{
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const organizationUID = get(activeClinicMembership, 'clinic.organizationUID');
    const pair = useAction(actions.pairScc, organizationUID);
    const cancelPairing = useAction(actions.pairSccCancel);
    useEffect(()=>{
        onSetHeaderMessage(messages.sccInstall.header);
        pair();
        return ()=>{
            onSetHeaderMessage();
            cancelPairing();
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.modal__content,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mt-6",
            children: [
                /*#__PURE__*/ _jsx(DownloadStep, {}),
                /*#__PURE__*/ _jsx(PairingStep, {}),
                /*#__PURE__*/ _jsx(ConnectionStep, {
                    onSetComponent: onSetComponent
                })
            ]
        })
    });
};
export default InstallDownloader;
